export default "__VITE_ASSET__CxGVXeBw__"